import { useCallback, useMemo } from 'react';

import { ICD9Procedure } from '@dreryk/egabinet-icd-dictionary-frontend-api';

import {
   createDynamicColumnsWidth,
   JustifyContent,
   Link,
   RemoveIcon,
   TableColumnConfiguration,
   ValueRendererProps,
} from '@dreryk/react-components';

import { referralIcd9ProcedureTranslationKeys } from '../../translations';

export const useIcd9ProceduresTableConfiguration = (
   removeItem?: (item: ICD9Procedure) => void
): TableColumnConfiguration<ICD9Procedure>[] => {
   const configuration = useCallback((): TableColumnConfiguration<ICD9Procedure>[] => {
      const columnsWidths = createDynamicColumnsWidth({
         code: '75px',
         name: '100%',
         options: '40px',
      });
      const optionsCell: TableColumnConfiguration<ICD9Procedure> | undefined = removeItem
         ? {
              name: 'options',
              label: '',
              width: columnsWidths.options,
              accessor: 'code',
              // Renderer is not a component

              renderer: (obj: ValueRendererProps<ICD9Procedure, any>): JSX.Element => {
                 return <Link icon={<RemoveIcon />} onClick={() => removeItem(obj.bean)} testId={'remove'} />;
              },
              sortingDisabled: true,
              justifyContent: JustifyContent.END,
           }
         : undefined;

      const cells: TableColumnConfiguration<ICD9Procedure>[] = [
         {
            label: referralIcd9ProcedureTranslationKeys.icd9ProcedureCode,
            width: columnsWidths.code,
            accessor: 'code',
            sortingDisabled: true,
         },
         {
            label: referralIcd9ProcedureTranslationKeys.icd9ProcedureName,
            width: columnsWidths.name,
            accessor: 'name',
            sortingDisabled: true,
         },
      ];
      if (optionsCell) {
         cells.push(optionsCell);
      }
      return cells;
   }, [removeItem]);

   return useMemo(configuration, [configuration]);
};
